import { STATUS_COMPLETE, STATUS_FAILED } from '../constants/manifest-segment-status';

export const segmentFromPushNotification = (message, segmentIndex) => {
  const {
    ScanFormId: scanFormId,
    ShipFromId: shipFromId,
    ShipmentCount: shipmentCount,
    HasSucceeded: hasSucceeded,
    ExceptionType: exceptionType,
  } = message;
  return {
    status: hasSucceeded ? STATUS_COMPLETE : STATUS_FAILED,
    scanFormId,
    shipFromId,
    shipmentCount,
    segmentIndex,
    exceptionType,
  };
};
